import { ProductMaskOptionsApiRemoteService } from '../../Services/api/product-mask-options/product-mask-options-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class DestroyProductMaskOptionUseCase
implements IFormUsecase<string, void> {
  constructor(private readonly ProductMaskOptionsApi: ProductMaskOptionsApiRemoteService) {}

  public async handle(id: string): Promise<Result<void>> {
    try {
      return await this.ProductMaskOptionsApi.destroy(id)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
